import React from 'react'
import { useNavigation } from 'hocs'
import { ScopeBadge } from 'uiComponents/searchScopeBadge'
import { getSearchByOptionByValue } from 'uiComponents/search/searchBar'
import { useTranslation } from 'translations'
import { getSearchByOptions } from './ordersSearchBar'

const SearchTermBadge: React.FC = () => {
    const { t } = useTranslation()
    const navigation = useNavigation()
    const query = navigation.query()

    if (!query.search) {
        return null
    }

    const option = getSearchByOptionByValue(getSearchByOptions(), query.searchBy)
    const label = `${option?.name ?? t('common.search')} "${query.search}"`

    return <ScopeBadge label={label} onClear={() => navigation.addQueryWithReplace({ search: '' })} />
}

export default SearchTermBadge
